<template lang="pug">
#Home.container-fluid
  #mainView.row.fullScreen.valign-wrapper
    .col.s12.center
      img#mainLogo(src="../assets/desktop/landing/2024/Desktop_HomePage_Logo.png")
  //- counter
  #LeadingBrands.row.valign-wrapper.relative
    img(src="../assets/desktop/landing/DoGreatWork_Desktop.svg")
  #GeneralMarket.row.valign-wrapper.relative
    img(src="../assets/desktop/landing/2024/Desktop_WeAreABlend.svg")
  #hipspanic.row.valign-wrapper.relative
    img(src="../assets/desktop/landing/WeHaveTheRightApproach_Desktop.svg")
  #thereisanew.row.valign-wrapper.relative.showHand(v-on:click="$router.push('OurWork')")
    img(src="../assets/desktop/landing/TheresaNewGeneration.svg")
  #OurClientExperience.row.relative
    .wrapper
      .col.s12.center
        span.Montserrat(style="font-size:45%") BRANDS WE’VE WORKED WITH
      .col.s12
        img(src="../assets/clients/LNH_Google.png")
        img(src="../assets/clients/LNH_BudLight.png")
        img(src="../assets/clients/LNH_Nike.png")
        img(src="../assets/clients/LNH_Dominos.png")
        img(src="../assets/clients/LNH_Airbnb.png")
        img(src="../assets/clients/LNH_att.png")
        img(src="../assets/clients/LNH_adidas.png")
        img(src="../assets/clients/LNH_Gatorade.png")
        img(src="../assets/clients/LNH_lyft.png")
        img(src="../assets/clients/LNH_apple.png")
        img(src="../assets/clients/LNH_heineken.png")
        img(src="../assets/clients/LNH_Youtube.png")
        img(src="../assets/clients/LNH_BurgerKing.png")
        img(src="../assets/clients/LNH_turbotax.png")
        img(src="../assets/clients/LNH_Volkswagen.png")
        img(src="../assets/clients/LNH_Equinox.png")
        img(src="../assets/clients/LNH_Target.png")
        img(src="../assets/clients/LNH_jetblue.png")
        img(src="../assets/clients/LNH_vrbo.png")
        img(src="../assets/clients/LNH_OfficeMax.png")
  //- #WhoWeAre.row.fullScreen.valign-wrapper.relative
  //-   img(src="../assets/hateHald.png")
  //-   .col.paddingLeft
  //-     p.Oswald.normalSize.textGrey We are a
  //-     p.Fjalla.largeSize STORYTELLING,
  //-     p.Fjalla.largerSize TECHNOLOGY
  //-     p.Fjalla.largeSize
  //-       span.blackAndWhiteBox AND STRATEGY LOVING
  //-     p.Oswald.normalishSize.textGrey.closeByLines boutique advertising agency that hates
  //-     p.Oswald.normalishSize.textGrey.closeByLines low standards and bad advertising.
  //-     p.Fjalla.smallerSize
  //-       span.AquaAndBlackBox.paddingSides.showHand(v-on:click="$router.push('OurWork')") SEE OUR WORK
  //- #WhoWeAre2.row.fullScreen.valign-wrapper.relative
  //-   img(src="../assets/WeWorkOn_Icon380.png")
  //-   .col.paddingLeft(style="font-size:120%")
  //-     p.Oswald.smallSize We work with brands we
  //-     p.Fjalla.largeSize LOVE
  //-       span(style="font-size:80%") ,
  //-       | LIVE AND
  //-     p.Fjalla.largerSize(style="margin-left: -0.5vw") BELIEVE IN
  //-       span.Oswald(style="line-height:0") .
  //-     p.Oswald.smallerSize.closeByLines Stuff that makes our eyes get bigger and our hearts beat faster.
  //-     p.Oswald.smallerSize.closeByLines Products and services that make our face light up when we write,
  //-     p.Oswald.smallerSize.closeByLines talk or tweet about them.
  //- #WhoWeAre3.row.fullScreen.valign-wrapper.relative
  //-   img(src="../assets/FoundersBio_Heart_Icon379.png")
  //-   .col.paddingLeft
  //-     p.Oswald.normalSize.textGrey Because if it means something to us,
  //-     p.Fjalla.largeSize
  //-       span.blackAndWhiteBox  NO ONE CAN SELL IT
  //-     p.largerSize.Fjalla(style="margin-left: -0.5vw") BETTER THAN US
  //-       span.Oswald .
  //-     p.Oswald.smallSize.textGrey.closeByLines  That’s why if you're looking for consumers to open their ears, hearts
  //-     p.Oswald.smallSize.textGrey.closeByLines and wallets to your brand, you need an agency that can tell your story
  //-     p.Oswald.smallSize.textGrey.closeByLines in a genuine, convincing and relatable voice. So, congratulations.
  //-     p.Oswald.smallSize.textGrey.closeByLines Your search for the right agency partner is officially over.
  //-     p(style="font-size:10%")  &nbsp
  //-     p.smallSize.Fjalla WHEN DO WE START?
  //- #WhatWeDo.row.fullScreen.valign-wrapper.relative
  //-   .col.paddingLeft
  //-     p.Fjalla.smallSize
  //-       span.AquaAndBlackBox.paddingSides WHAT WE DO
  //-     p.Fjalla.largeSize WE FIND THE MOST
  //-     p.Fjalla.largerSize(style="margin-left: -0.5vw") LOVABLE TRAITS
  //-     p.Fjalla
  //-       span.WhiteAndBlackBox ABOUT YOUR BRAND
  //-         span.Oswald(style="line-height:0") .
  //-     p.Oswald.smallerSize.closeByLines Strategically position you in the marketplace. Create a story only you can tell.
  //-     p.Oswald.smallerSize.closeByLines Find the right medium. If it doesn't exist, we make it exist.
  //-     p.Oswald.smallerSize.closeByLines Scream it to the world in a genuine, provocative and relatable voice.
  //- #WorksPictures.row.relative
  //-   .col.s4.relative.showHand#work(v-on:click="$router.push('/work/BUD LIGHT PARTY');")
  //-     img(src="../assets/works/BudLight_Thumb.png")
  //-     p.Fjalla.smallestSize.title.center BUD LIGHT PARTY
  //-   .col.s4.relative.showHand#work(v-on:click="$router.push('/work/THE LETGO COMMERCIALIZER');")
  //-     img(src="../assets/works/LetGo_Thumb.png")
  //-     p.Fjalla.smallestSize.title.center THE LETGO COMMERCIALIZER
  //-   .col.s4.relative.showHand#work(v-on:click="$router.push('/work/EQUINOX');")
  //-     img(src="../assets/works/Equinox_Thumb.png")
  //-     p.Fjalla.smallestSize.title.center EQUINOX
  //-   div.center
  //-     span.Fjalla.smallerSize.blackAndWhiteBox.paddingSides.showHand(v-on:click="$router.push('OurWork')") SEE OUR WORK
  #NewCapabilities.row.fullScreen.valign-wrapper.relative
    img#CAP(src="../assets/FoundersBio_CircleIcon378.png")
    .col.paddingLeft
      div.container-special
        div.left-line
        span#title CAPABILITIES
        div.right-line
      div.row#capabilities-list
        capabilities(key="NewCapabilities")
  #Founders.row.fullScreen.valign-wrapper.relative
    img(src="../assets/BigH_Founders.png")
    span.Fjalla.normalSize.AquaAndBlackBox.paddingSides &nbsp&nbsp&nbspFounders&nbsp&nbsp&nbsp
  #Founders2.row.fullScreen.relative
    img#FH(src="../assets/FoundersBio_Heart_Icon379.png")
    img#FC(src="../assets/FoundersBio_CircleIcon378.png")
    .col.s6(style="padding-left:7.5vw")
      p.Fjalla.smallSize.closeByLines Roberto Lastra
      p.Fjalla.smallestSize.textGrey.closeByLines(style="font-size:40%;") Creative Director/Founder/Ironman
      .blueLine
      .description.Oswald.textGrey
        p Shameless namedropping coming your way in 3...2...1...<br>Global Creative Director on Gatorade. Creative Director and Consultant at swanky agencies like Wieden + Kennedy, Crispin Porter + Bogusky, Goodby, Silverstein and Partners, Fallon Worldwide and pretty much every major agency out there as a freelancer. Yes, it's true. Roberto has deliberately stolen pens and used printers for personal gains at the most important advertising agencies in the world. He's also worked there. But what he really wants you to know is that he was born in a place called the "City of the Cold Eggs" because it's so hot, everyone drives around with a beer in between their legs.
        p He's also supposed to write something impressive about how impressive his resume is. Which it is. But he rather talk about how by the age of 24, he had been fired from ten professional soccer teams. Now that's impressive.
        p And a quote. A great quote about building brands and cutting through the clutter or some other marketing cliche would go here. Instead, he'll just tell you about how he likes to lead by example, exercise to exhaustion and finally be able to steal pens from an agency that's actually his.
    .col.s6(style="padding-right:7.5vw")
      p.Fjalla.smallSize.closeByLines Constanza Peuriot
      p.Fjalla.smallestSize.textGrey.closeByLines(style="font-size:40%;") Founder/Managing Director/Mother of Dragons
      .blueLine
      .description.Oswald.textGrey
        p A three-sport star athlete in High School, Constanza was born in Argentina and moved to Madrid, Spain, at the age of one. She attended Universidad Pontificia Comillas and Northeastern University in Boston where she completed her Bachelors in International Business. After flipping the tassel over to the left, she moved to New York City to start her career at Havas Media (formerly known as MPG) as a Global Marketing Coordinator, quickly moving up the ranks to become the Global CEO’s right hand. At the early age of 29 she became SVP Global New Business at BPN, where she supported more than 40 offices around the world in global new business pitches and marketing efforts.
        p At LNH her responsibilities include carrying the whip to make sure everything runs smoothly. But she does it with a smile and a personality that is loved by everyone she spends more than 30 seconds with. Chief People Officer, Culture Curator, Director of Client Services and Superwoman are among the titles that have been proposed by her co-workers. She prefers I Get SH*%T Done Director.
</template>

<script>
window.$ = require("jquery");
$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  if (window.location.pathname == "/") {
    if ($("#Founders").offset().top - 50 < scrollTop) {
      $("#navbar a").removeClass("active");
      $("#A-Founders").addClass("active");
    } else {
      if ($("#NewCapabilities").offset().top - 50 < scrollTop) {
        $("#navbar a").removeClass("active");
        $("#A-Capabilities").addClass("active");
      } else {
        if ($("#LeadingBrands").offset().top - 50 < scrollTop) {
          $("#navbar a").removeClass("active");
          $("#A-Leading-Brands").addClass("active");
        } else {
          $("#navbar a").removeClass("active");
        }
      }
    }
  }
});
import counter from "./counter";
import capabilities from "./capabilities";
export default {
  mounted() {
    if ( navigator.platform.toUpperCase().indexOf('MAC')>=0) $("body").addClass("mac-os");
  },
  components: {
    counter,
    capabilities,
  },
};
</script>

<style lang="sass">
.paddingLeft
  padding-left: 20vw !important
.blueLine
  position: relative
  &:after
    content: ''
    position: absolute
    width: 12vw
    bottom: vw
    left: 0px
    border-bottom: 0.3vw solid #00FFFF
    z-index: 90
#mainView
  background-image: url("../assets/MainBG_HighRes_opt.jpg")
  background-size: cover
  background-repeat: no-repeat
  background-position: center
  #mainLogo
    width: 27vw
#WhoWeAre
  img
    position: absolute
    left: -10px
    top: 50%
    //height: 65%
    width: 18vw
    max-height: 80%
    transform: translate(0%,-50%)
#WhoWeAre2
  background-color: black
  color: white
  background-image: url("../assets/WeWorkOn_1280_Jpeg50.jpg")
  background-size: cover
  -webkit-background-size: cover
  -moz-background-size: cover
  -o-background-size: cover
  background-position: center center
  background-repeat: no-repeat
  img
    position: absolute
    right: -10px
    top: 50%
    width: 20vw
    max-height: 80%
    transform: translate(0,-50%)
#LeadingBrands
  color: black
  margin-bottom: 0
  img
    width: 100%
    height: auto
#GeneralMarket
  color: black
  margin-bottom: 0
  overflow: hidden
  margin-bottom: -2px
  img
    height: auto
    width: 101%
    margin-left: -1%
    margin-top: -2px
#hipspanic
  color: black
  margin-bottom: 0
  img
    width: 100%
    height: auto
#thereisanew
  color: black
  margin-bottom: 0
  img
    top: -30px
    width: 100%
    height: auto
#WhoWeAre3
  color: black
  img
    position: absolute
    bottom: 0px
    right: 0px
    width: 25vw
    z-index: -1
#WhatWeDo
  background-color: black
  background-image: url("../assets/WeWorkOn_FinalBACKGROUND.png")
  background-size: cover
  -webkit-background-size: cover
  -moz-background-size: cover
  -o-background-size: cover
  background-position: center center
  background-repeat: no-repeat
  color: white
#OurClientExperience
  background-color: black
  margin-bottom: 0px
  color: rgb(85, 85, 85)
  .wrapper
    max-width: 85%
    margin-left: auto
    margin-right: auto
  img
    display: inline
    padding-left: 9px
    padding-right: 9px
    width: 8%
    margin: 1%
#Capabilities
  img.big-H
    position: absolute
    top: 50%
    right: -10px
    transform: translate(0, -50%) rotate(180deg)
    width: 18vw
    max-height: 80%
#Founders
  background-image: url("../assets/Founders_1366_opt.jpg")
  background-size: cover
  -webkit-background-size: cover
  -moz-background-size: cover
  -o-background-size: cover
  background-position: center center
  background-repeat: no-repeat
  span
    position: absolute
    bottom: 5%
    left: 50%
    transform: translate(-50%,0)
  img
    position: absolute
    bottom: -10px
    width: 12vw
#Founders2
  padding-top: 40px
  font-size: 3.2vw
  padding-bottom: 18vw
  .col
    padding-left: 3.2vw
    padding-right: 3.2vw
  p
    line-height: 1.5
  .description
    font-size: 45%
  img#FH
    position: absolute
    bottom: 0px
    right: 0px
    width: 20vw
  img#FC
    position: absolute
    bottom: 0px
    left: 21vw
    width: 20vw
#NewCapabilities
  background-color: black
  div.container-special
    width: 30vw
    display: flex
    display  : -webkit-box;
    display  : -ms-flexbox;
    display  : -webkit-flex;
    flex: flex-wrap
    align-items: center
    margin-bottom: 20px
    span#title
      color: #00FFFF
      font-family: 'Fjalla One', sans-serif
      font-size: 70%
      line-height: 100%
      margin-left: 2%
      margin-right: 2%
    div.left-line
      display: flex
      align-items: center
      content: ""
      border-top: 2px solid #00FFFF
      flex: 2
    div.right-line
      display: flex
      align-items: center
      content: ""
      border-top: 2px solid #00FFFF
      flex: 9
  img#CAP
    position: absolute
    bottom: -5%
    right: 5vw
    width: 20vw
    webkit-filter: grayscale(1) invert(1)
    filter: grayscale(1) invert(1)
  .paddingLeft
    padding-left: 16vw !important
#WorksPictures
  margin-bottom: 0px

// detecting mac-os
body.mac-os
  #NewCapabilities
</style>



// WEBPACK FOOTER //
// src/components/main.vue